import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.single-line-text-field.icon-label',
		defaultMessage: 'Single line text field icon',
		description: 'Label for the single line text field icon',
	},
});

export function SingleLineTextFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<AlignTextLeftIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
